import React from "react";
import { Link } from "react-router-dom";
import { Phone, MapPin, Clock } from "lucide-react";
import { CLINIC, HOURS, getOpenStatus } from "@/data/constants";

export const Footer = () => {
  const status = getOpenStatus();
  const todayIdx = (new Date().getDay() + 6) % 7; // Mon=0 ... Sun=6

  return (
    <footer data-testid="site-footer" className="bg-sage-900 text-sage-100">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid md:grid-cols-3 gap-12">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <div className="w-11 h-11 rounded-full bg-sage-50 flex items-center justify-center">
              <span className="font-heading text-sage-900 text-2xl leading-none">K</span>
            </div>
            <div>
              <div className="font-heading text-2xl text-sage-50">Kalpataru</div>
              <div className="text-[11px] uppercase tracking-[0.2em] text-sage-400">
                Dental Care
              </div>
            </div>
          </div>
          <p className="text-sage-300 text-sm leading-relaxed max-w-xs">
            Modern, compassionate dental care in the heart of Nagpur. Creating healthy,
            confident smiles.
          </p>
          <div className="mt-5 space-y-2 text-sm">
            <a
              href={`tel:${CLINIC.phone}`}
              className="flex items-center gap-2 text-sage-200 hover:text-white transition-colors"
              data-testid="footer-phone"
            >
              <Phone size={16} /> {CLINIC.phoneDisplay}
            </a>
            <a
              href={CLINIC.mapsLink}
              target="_blank"
              rel="noreferrer"
              className="flex items-start gap-2 text-sage-200 hover:text-white transition-colors"
            >
              <MapPin size={16} className="mt-0.5 shrink-0" /> {CLINIC.address}
            </a>
          </div>
        </div>

        <div data-testid="footer-clinic-hours">
          <div className="flex items-center gap-2 mb-4">
            <Clock size={18} className="text-sage-400" />
            <h4 className="font-heading text-2xl text-sage-50">Clinic Hours</h4>
            <span
              data-testid="footer-status-badge"
              className={`ml-2 inline-flex items-center gap-1.5 text-[11px] font-700 px-2.5 py-1 rounded-full ${
                status.open ? "bg-emerald-500/20 text-emerald-300" : "bg-terracotta/20 text-terracotta"
              }`}
            >
              <span
                className={`w-1.5 h-1.5 rounded-full ${
                  status.open ? "bg-emerald-400" : "bg-terracotta"
                }`}
              />
              {status.label}
            </span>
          </div>
          <ul className="space-y-1.5 text-sm">
            {HOURS.map((h, i) => (
              <li
                key={h.day}
                className={`flex justify-between border-b border-sage-800 pb-1.5 ${
                  i === todayIdx ? "text-sage-50 font-700" : "text-sage-300"
                }`}
              >
                <span>{h.day}</span>
                <span>
                  {h.open} – {h.close}
                </span>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-2xl text-sage-50 mb-4">Quick Links</h4>
          <ul className="space-y-2 text-sm text-sage-300">
            <li><Link to="/" className="hover:text-white transition-colors">Home</Link></li>
            <li><a href="/#doctor" className="hover:text-white transition-colors">About the Doctor</a></li>
            <li><a href="/#services" className="hover:text-white transition-colors">Our Services</a></li>
            <li><Link to="/contact" className="hover:text-white transition-colors">Book Appointment</Link></li>
            <li><Link to="/admin" className="hover:text-white transition-colors" data-testid="footer-admin-link">Admin Login</Link></li>
          </ul>
          <a
            href={CLINIC.mapsLink}
            target="_blank"
            rel="noreferrer"
            data-testid="footer-directions"
            className="inline-flex items-center gap-2 mt-6 bg-sage-400 hover:bg-sage-500 text-white text-sm font-700 px-5 py-2.5 rounded-full transition-colors"
          >
            <MapPin size={16} /> Get Directions
          </a>
        </div>
      </div>
      <div className="border-t border-sage-800 py-5 text-center text-xs text-sage-400">
        © {new Date().getFullYear()} Kalpataru Dental Care · Dr. Ruchika Vivek Sontakay (BDS) · Nagpur
      </div>
    </footer>
  );
};
